//#region src/components/Menu/MenuTitle.module.css
var MenuTitle_module_default = { "menu-title": "_menu-title_1sgvx_8" };
//#endregion
export { MenuTitle_module_default as default };

//# sourceMappingURL=MenuTitle.module.js.map